import { Pipe, PipeTransform } from '@angular/core';
import { CampaignTextField } from '@Interfaces/rewards.interfaces';

@Pipe({
  name: 'getTranslation',
  standalone: true
})
export class GetRewardsTranslationPipe implements PipeTransform {

  transform(translations: CampaignTextField[] | undefined | null, key: string): string {
    if (!translations) return '';
    const found = translations.find(t => t.key === key);
    return found ? found.value : '';
  }

}
